/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { removeInitLoader } from '../../app/initialization';
import { authenticate, logout } from '../../app/store/actions/auth';
import { mergeCart } from '../../app/store/actions/cart';
import { addLoading, removeLoading } from '../../app/store/actions/loading';
import { updatePunchOutData } from '../../app/store/actions/punchOut';
import ROUTES from '../../data/routes';
import StringHelper from '../../helpers/string';
import { history } from '../../routers/AppRouter';

export class PunchOutLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
    };
  }

  async componentDidMount() {
    await this.submit();
  }

  async componentWillReceiveProps(nextProps) {
    const { contractsTotal, isAuthenticated, productCode } = nextProps;
    const productDetails = productCode ? `${ROUTES.PRODUCTS}/${productCode}/0` : '';
    if (isAuthenticated && productDetails) {
      history.push(productDetails);
      window.scrollTo(0, 0);
    } else if (isAuthenticated) {
      history.push(ROUTES.HOME, { showContracts: contractsTotal > 1 });
    }
  }

  getPunchOutData() {
    let hookUrl = this.props.hookUrl
    || this.props.hookurl
    || this.props.HOOKURL
    || this.props.HOOK_URL
    || this.props.hook_url;

    if (this.props.PARTNERID) {
      hookUrl += `&PARTNERID=${this.props.PARTNERID}`;
    }

    if (this.props.SUPPLIER_NAME) {
      hookUrl += `&SUPPLIER_NAME=${this.props.SUPPLIER_NAME}`;
    }

    if (this.props.POID) {
      hookUrl += `&POID=${this.props.POID}`;
    }

    if (this.props._csrf) {
      hookUrl += `&_csrf=${this.props._csrf}`;
    }
    console.log(this.props, 'props')

    return {
      userId: this.props.userId || StringHelper.generateRandomToken(),
      hookUrl,
      buyerCookie: this.props.buyerCookie,
      userAgent: this.props.userAgent,
    };
  }

  submit = async () => {
    this.props.addLoading();
    if (this.props.email && this.props.password) {
      try {
        await this.props.setPunchOutData(this.getPunchOutData());
        await this.props.authenticate(this.props.email, this.props.password, 'punchout');
      } catch (error) {
        if (error.response && error.response.data.error.code === 209) {
          this.setState({ error: I18n.t('userBlocked') });
        } else if (error.response && error.response.data.error.code === 400) {
          this.setState({ error: I18n.t('userNotFound') });
        } else if (error.response && error.response.data.error.code === 407) {
          this.setState({ error: I18n.t('userInvalidPassword') });
        } else {
          this.setState({ error: I18n.t('errorTryLater') });
        }
      } finally {
        this.props.removeLoading();
        removeInitLoader();
      }
    } else {
      this.setState({ error: I18n.t('userInvalid') });
      this.props.removeLoading();
      removeInitLoader();
    }
  };

  render() {
    const { error } = this.state;
    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <div className="box-content">
              <div className="basket cart-status">
                {!!error && (<span className="cart-status-image" style={{ backgroundImage: 'url(/images/erro-404.svg)' }} />)}
                <p style={{ fontSize: 'x-large' }}>{error}</p>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticated,
  contractsTotal: state.contracts.list.length,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  authenticate: (email, password, scope) => dispatch(authenticate(email, password, scope)),
  setPunchOutData: punchOutData => dispatch(updatePunchOutData(punchOutData)),
  mergeCart: () => dispatch(mergeCart()),
  addLoading: () => dispatch(addLoading()),
  removeLoading: () => dispatch(removeLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PunchOutLoginForm);
